<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>Apple Wallet</ion-title>

        <ion-buttons slot="end">
          <ion-button @click="close">
            Schließen
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <div class="wallet-content">
        <h2>Apple Wallet</h2>

        <p>Clubkarte zu Apple Wallet hinzufügen</p>

        <a
          v-if="propsData.appleUrl"
          :href="propsData.appleUrl"
          class="wallet-button"
        >
          Add to Apple Wallet
        </a>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  modalController
} from '@ionic/vue'

export default {
  name: 'AppleWalletDialog',

  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent
  },

  props: {
    propsData: {
      type: Object,
      required: true
    }
  },

  methods: {
    close() {
      modalController.dismiss()
    }
  }
}
</script>

<style scoped>
.wallet-content {
  padding: 40px 20px;
  text-align: center;
  color: #000;
}

.wallet-content h2 {
  margin-bottom: 16px;
}

.wallet-content p {
  margin-bottom: 30px;
}

.wallet-button {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 20px;
  background: #000;
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  font-size: 17px;
  font-weight: 600;
}
</style>